import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import GoogleLoginButton from '../components/GoogleLoginButton';

const SignInPage = () => {
  const { isSignedIn, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '', remember: false });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (isSignedIn) return <Navigate to="/dashboard" replace />;

  const submit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      await login(form);
      navigate('/dashboard', { replace: true });
    } catch (requestError) {
      setError(requestError.response?.data?.message || 'Unable to sign in. Please check your details.');
    } finally {
      setSubmitting(false);
    }
  };

  return <AuthCard title="Welcome back">
    <form onSubmit={submit} className="space-y-5">
      <GoogleLoginButton />
      <div className="flex items-center gap-3 text-xs uppercase tracking-wide text-gray-500"><span className="h-px flex-1 bg-gray-800" />or use email<span className="h-px flex-1 bg-gray-800" /></div>
      {error && <div role="alert" className="rounded border border-red-500 bg-red-950/50 p-3 text-red-200">{error}</div>}
      <Field label="Email" type="email" value={form.email} onChange={(email) => setForm({ ...form, email })} autoComplete="email" />
      <Field label="Password" type="password" value={form.password} onChange={(password) => setForm({ ...form, password })} autoComplete="current-password" />
      <label className="flex items-center gap-2 text-sm text-gray-300"><input type="checkbox" checked={form.remember} onChange={(event) => setForm({ ...form, remember: event.target.checked })} /> Remember me</label>
      <button disabled={submitting} className="w-full rounded bg-yellow-400 px-4 py-3 font-bold text-black disabled:opacity-60">{submitting ? 'Signing in…' : 'Sign in'}</button>
      <p className="text-center text-gray-400">New to iStockly? <Link className="text-yellow-400" to="/sign-up">Create an account</Link></p>
    </form>
  </AuthCard>;
};

const AuthCard = ({ title, children }) => <div className="min-h-screen bg-black px-4 pt-28"><div className="mx-auto max-w-md rounded-xl border border-yellow-400/30 bg-gray-900 p-8"><h1 className="mb-6 text-3xl font-bold text-white">{title}</h1>{children}</div></div>;
const Field = ({ label, onChange, ...props }) => <label className="block text-sm font-medium text-gray-300">{label}<input required {...props} onChange={(event) => onChange(event.target.value)} className="mt-2 w-full rounded border border-gray-700 bg-gray-800 px-3 py-3 text-white focus:border-yellow-400 focus:outline-none" /></label>;

export { AuthCard, Field };
export default SignInPage;
